import { useState } from 'react';
import { faqItems } from '@/mocks/home';

export default function FAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        {/* Section header */}
        <div className="text-center mb-10">
          <h3 className="text-sm font-semibold text-primary-500 uppercase tracking-wider mb-2">
            <i className="ri-question-answer-line mr-1.5"></i>
            常见问题
          </h3>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            关于麻花影视
          </h2>
        </div>

        {/* FAQ List */}
        <div className="space-y-3">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="rounded-xl bg-background-50 border border-background-200/70 overflow-hidden transition-all duration-200"
            >
              <button
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer"
              >
                <span className="text-sm font-medium text-foreground-900 pr-4">
                  {item.q}
                </span>
                <div
                  className={`w-7 h-7 flex items-center justify-center rounded-full flex-shrink-0 transition-all duration-300 ${
                    openIdx === idx
                      ? 'bg-primary-500 text-white rotate-45'
                      : 'bg-background-200 text-foreground-500'
                  }`}
                >
                  <i className="ri-add-line text-sm"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIdx === idx ? 'max-h-64 pb-5 px-5' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}